<template>
  <div :style="themePageStyle">
    <!-- Header -->
    <div class="dev-topbar">
      <div class="dev-topbar-inner">
        <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="dev-brand">
          <img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:28px;"/>
          <span class="dev-brand-tag">Developers</span>
        </a>
        <div class="dev-nav">
          <a href="javascript:void(0)" @click="$router.push('/developers')" class="dev-nav-link active">Apps</a>
          <a href="javascript:void(0)" @click="$router.push('/developers/docs')" class="dev-nav-link">Docs</a>
          <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="dev-nav-link" style="opacity:0.7;">← Back to Flockr</a>
        </div>
      </div>
    </div>

    <div class="container py-4" style="max-width:1100px;">
      <!-- Hero -->
      <div class="dev-hero mb-4">
        <div>
          <div class="dev-kicker">Flockr API · v1</div>
          <h2 class="fw-bold mb-1" :style="{color:'var(--fm-h,#F5F0E8)'}">Build on Flockr</h2>
          <p class="mb-0" :style="{color:'var(--fm-s,#6B6356)',fontSize:'14px',maxWidth:'600px'}">
            Read listings, sync transactions, and subscribe to real-time webhook events.
            Create an app, get an API key, and you're integrated in minutes.
          </p>
        </div>
        <button class="btn btn-warning fw-bold" @click="showCreate=true">
          <i class="mdi mdi-plus me-1"></i> New App
        </button>
      </div>

      <!-- Apps list -->
      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

      <div v-else-if="apps.length === 0" class="dev-empty">
        <i class="mdi mdi-cube-outline" style="font-size:48px;color:#6B6356;opacity:0.4;"></i>
        <h5 class="mt-3" :style="{color:'var(--fm-h,#F5F0E8)'}">No apps yet</h5>
        <p :style="{color:'var(--fm-s,#6B6356)',fontSize:13}">Create your first app to start using the Flockr API.</p>
        <button class="btn btn-warning fw-bold mt-2" @click="showCreate=true">
          <i class="mdi mdi-plus me-1"></i> Create your first app
        </button>
      </div>

      <div v-else class="row g-3">
        <div v-for="a in apps" :key="a.id" class="col-12 col-md-6">
          <div class="dev-app-card" @click="$router.push('/developers/apps/' + a.id)">
            <div class="d-flex align-items-start justify-content-between">
              <div style="min-width:0;">
                <div class="dev-app-name">{{ a.name }}</div>
                <div class="dev-app-desc text-truncate">{{ a.description || 'No description' }}</div>
              </div>
              <i class="mdi mdi-chevron-right" style="color:#6B6356;font-size:24px;"></i>
            </div>
            <div class="dev-app-meta">
              <span class="dev-pill dev-pill-key">
                <i class="mdi mdi-key-variant"></i> {{ a.active_keys }} key{{ a.active_keys === '1' ? '' : 's' }}
              </span>
              <span class="dev-pill dev-pill-hook">
                <i class="mdi mdi-webhook"></i> {{ a.active_hooks }} webhook{{ a.active_hooks === '1' ? '' : 's' }}
              </span>
              <span class="dev-pill dev-pill-time">{{ fmtDate(a.created_at) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Create App Modal -->
      <div v-if="showCreate" class="dev-modal" @click.self="showCreate=false">
        <div class="dev-modal-card">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0" :style="{color:'var(--fm-h,#F5F0E8)'}">Create New App</h5>
            <button class="dev-modal-close" @click="showCreate=false"><i class="mdi mdi-close"></i></button>
          </div>
          <label class="dev-label">App name</label>
          <input v-model="newApp.name" class="form-control mb-2" placeholder="e.g. ZEP-RE Digital Inclusivity" :style="themeInputStyle"/>
          <label class="dev-label">Description (optional)</label>
          <textarea v-model="newApp.description" class="form-control mb-3" rows="2" placeholder="What is this app for?" :style="themeInputStyle"></textarea>
          <button class="btn btn-warning w-100 fw-bold" :disabled="!newApp.name.trim() || creating" @click="createApp">
            <span v-if="!creating">Create App</span>
            <span v-else><i class="mdi mdi-loading mdi-spin"></i> Creating...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { executeJson, flocker } from "@/api";
export default {
  name: "DevelopersHome",
  data() { return {
    loading: true,
    apps: [],
    showCreate: false,
    creating: false,
    newApp: { name: '', description: '' },
    darkMode: (document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark') !== 'light',
  }},
  computed: {
    themePageStyle() { return this.darkMode ? 'background:#0A0A0A;min-height:100vh;color:#F5F0E8;' : 'background:#F7F5F2;min-height:100vh;color:#1A1A1A;' },
    themeInputStyle() { return this.darkMode ? 'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;' : 'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;' },
  },
  mounted() {
    const t = localStorage.getItem('flockr_theme') || 'dark'; window.__flockrSetTheme && window.__flockrSetTheme(t);
    const u = sessionStorage.getItem('userId');
    if (!u) { this.$router.push('/login?redirect=/developers'); return; }
    this.fetchApps();
  },
  methods: {
    async fetchApps() {
      this.loading = true;
      try {
        const r = await executeJson({ function: 'listDeveloperApps', userId: sessionStorage.getItem('userId') }, flocker);
        if (r.data.success) this.apps = (r.data.data && r.data.data.apps) || [];
      } catch(e) { console.error(e); }
      this.loading = false;
    },
    async createApp() {
      if (!this.newApp.name.trim()) return;
      this.creating = true;
      try {
        const r = await executeJson({
          function: 'createDeveloperApp',
          userId: sessionStorage.getItem('userId'),
          name: this.newApp.name.trim(),
          description: this.newApp.description.trim(),
        }, flocker);
        if (r.data.success) {
          this.showCreate = false;
          this.newApp = { name: '', description: '' };
          this.$router.push('/developers/apps/' + r.data.data.id);
        } else {
          alert(r.data.message || 'Failed to create app');
        }
      } catch(e) { alert('Connection error'); }
      this.creating = false;
    },
    fmtDate(s) { if (!s) return ''; const d = new Date(s.replace(' ', 'T')); return d.toLocaleDateString('en-GB', {day:'numeric',month:'short',year:'numeric'}); },
  }
}
</script>

<style>
.dev-topbar { background: var(--fm-bg1, #141414); border-bottom: 1px solid var(--fm-br, #1E1E1E); }
.dev-topbar-inner { max-width: 1100px; margin: 0 auto; padding: 14px 20px; display: flex; align-items: center; justify-content: space-between; }
.dev-brand { display: flex; align-items: center; gap: 10px; text-decoration: none; }
.dev-brand-tag { color: #BFA164; font-weight: 800; font-size: 14px; letter-spacing: 1px; text-transform: uppercase; padding-left: 10px; border-left: 1px solid #2A2520; }
.dev-nav { display: flex; gap: 18px; }
.dev-nav-link { color: var(--fm-s, #A09888); text-decoration: none; font-size: 13px; font-weight: 600; padding: 4px 0; }
.dev-nav-link.active { color: var(--fm-h, #F5F0E8); border-bottom: 2px solid #BFA164; }
.dev-nav-link:hover { color: var(--fm-h, #F5F0E8); }

.dev-hero { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; flex-wrap: wrap; }
.dev-kicker { color: #BFA164; font-weight: 800; font-size: 11px; letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 4px; }

.dev-empty { background: var(--fm-bg1, #141414); border: 1px solid var(--fm-br, #1E1E1E); border-radius: 14px; padding: 50px 20px; text-align: center; }

.dev-app-card { background: var(--fm-bg1, #141414); border: 1px solid var(--fm-br, #1E1E1E); border-radius: 12px; padding: 18px; cursor: pointer; transition: transform .15s, border-color .15s; }
.dev-app-card:hover { transform: translateY(-2px); border-color: #BFA164; }
.dev-app-name { color: var(--fm-h, #F5F0E8); font-weight: 700; font-size: 15px; }
.dev-app-desc { color: var(--fm-s, #6B6356); font-size: 12.5px; margin-top: 2px; }
.dev-app-meta { display: flex; gap: 6px; margin-top: 12px; flex-wrap: wrap; }

.dev-pill { display: inline-flex; align-items: center; gap: 4px; font-size: 11px; padding: 3px 9px; border-radius: 12px; font-weight: 600; }
.dev-pill-key { background: rgba(191, 161, 100, 0.15); color: #BFA164; }
.dev-pill-hook { background: rgba(80, 200, 120, 0.12); color: #50C878; }
.dev-pill-time { background: rgba(160, 152, 136, 0.12); color: #A09888; }

.dev-label { color: var(--fm-s, #A09888); font-size: 12px; font-weight: 600; margin-bottom: 4px; display: block; }

.dev-modal { position: fixed; inset: 0; background: rgba(0,0,0,.7); display: flex; align-items: center; justify-content: center; z-index: 1050; padding: 20px; }
.dev-modal-card { background: var(--fm-bg1, #141414); border: 1px solid var(--fm-br, #2A2520); border-radius: 14px; padding: 24px; width: 100%; max-width: 460px; }
.dev-modal-close { background: transparent; border: none; color: #A09888; width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 18px; }
.dev-modal-close:hover { background: rgba(255,255,255,.06); color: #F5F0E8; }
</style>
